import React from 'react';
import styles from './Process.module.css';
import useReveal from './useReveal';

const steps = [
  { num: '01', name: 'Discovery', desc: 'Understanding business goals & digital challenges.' },
  { num: '02', name: 'Strategy', desc: 'Creating a custom technology & marketing plan.' },
  { num: '03', name: 'Development', desc: 'Building modern platforms & marketing systems.' },
  { num: '04', name: 'Optimization', desc: 'Improving performance, SEO & campaigns.' },
  { num: '05', name: 'Deployment', desc: 'Launching with seamless integration.' },
  { num: '06', name: 'Growth', desc: 'Ongoing support for long-term success.' },
];

export default function Process() {
  const headRef = useReveal();
  const stepsRef = useReveal();

  return (
    <section className={styles.process} id="process">
      <div className={`reveal ${styles.head}`} ref={headRef}>
        <span className="section-label">// our process</span>
        <h2 className="section-title">How We <em>Build &amp; Grow</em></h2>
        <p className="section-sub">A clear, proven methodology from discovery to long-term growth support.</p>
      </div>

      <div className={`reveal ${styles.steps}`} ref={stepsRef}>
        <div className={styles.connector} />
        {steps.map((s) => (
          <div key={s.num} className={styles.step}>
            <div className={styles.dot}>{s.num}</div>
            <h4 className={styles.name}>{s.name}</h4>
            <p className={styles.desc}>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
